import {Imports, ITransform} from "./base/editor.interfaces";
import {commonEventInfo, FabricHelpers} from "./base/fabric-helpers";
import {IEditorClipart, IEditorText} from "@/customizer/interfaces";
import {IEditorShape, IEditorEditorPhoto, IEditorPhotoGroup, IEditorEditorImage, IEditorCanvas} from "./base/editor.interfaces";
import {EditorHelpers} from "./base/helpers";
import {fabric} from "fabric";

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;
const SF = globalImports.SF || (globalImports.SF = globalImports.SF || {});
globalImports.SF.Editor = globalImports.SF.Editor  || {};
const HandleLayout = globalImports.SF.Model.HandleLayout;
const ProductAttribute = globalImports.SF.Model.EditorBleedProperties;
const WrapOptions = globalImports.SF.Model.WrapOptions;
const EVENT_CANVAS_RENDER_MASK: string = 'CanvasRenderMask';
const EVENT_CANVAS_RENDER_NON_PRINTABLE_BACKGROUND: string = 'CanvasRenderNonPrintableBackground';
fabric.Object.prototype.set({handleLayout: 'mobile'} as any);

// @ts-ignore
fabric.Object.prototype.disableDashedBorder = function (): boolean {
    // disable border if there is only element (products with wrap as well as 2 page products like mugs doesn't show the border properly)
    // tslint:disable-next-line:no-invalid-this
    return this.canvas.getObjects().length === 1;
};

// tslint:disable no-invalid-this
SF.Editor.Canvas = fabric.util.createClass(globalImports.SF.Editor.Canvas, {

    setCursor: function (value: string): void {
        const activeObj = this.getActiveObject();
        const isEmptyImage = activeObj && activeObj.photoObject && !activeObj.photoObject.image;
        this.callSuper('setCursor', value, isEmptyImage);
    },

    /**
     *
     * @param e
     * @param transform
     * @param pointer
     * @private
     */
    _performTransformAction: function (e: Event, transform: ITransform, pointer: { x: number, y: number }): void {
        const x = pointer.x;
        const y = pointer.y;
        const target = transform.target;
        // if our target is an object inside a group we shouldn't respond to performTransformAction
        if (target.group && this.getObjects().indexOf(target) < 0) {
            return;
        }
        const action = transform.action;
        let actionPerformed = false;
        let currentStackIndex;
        if (action === 'innerRotate') {
            actionPerformed = this._innerRotateObject(x, y);
            if (actionPerformed) {
                this._fire('innerRotating', commonEventInfo(e, target));
            }
        } else if (action === 'pan' || action === 'drag') {
            actionPerformed = this._pan(x, y);
            if (actionPerformed) {
                this._fire('panning',  commonEventInfo(e, target));
                if (target.type != 'background') {
                    currentStackIndex = this.getObjects().indexOf(target);
                    document.dispatchEvent(new CustomEvent('panStart', {detail: {target, currentStackIndex}}));
                    target.bringToFront();
                }
            }
            this.setCursor('clenchedFist');

        } else if (action === 'scale' || action === 'scaleX' || action === 'scaleY') {
            actionPerformed = this.scaleObject(e, x, y, action);
            if (actionPerformed) {
                this._fire('scaling',  commonEventInfo(e, target));
            }
        } else {

            this.callSuper('_performTransformAction', e, transform, pointer);

        }

        if (!transform.actionPerformed) {
            transform.actionPerformed = actionPerformed;
        }
        this._previousMovePointer = pointer;
    },

    // tslint:disable no-invalid-this
    __gesturesRenderer: function (): void {

        if (this.__gesturesParams === null || this._currentTransform === null) {
            return;
        }
        const self = this.__gesturesParams.self;
        const t = this._currentTransform;

        const target = t.target;
        if (!target || target.isLetterBoxed || (target.type == 'background' && target.photoObject.image.type == 'background' && target.locked)) {
            return;
        }

        this.pinchZoom(this, self);
        this.touchRotation(this, self);
        this.renderAll();
        t.action = '';
        this.fire('object:modified', {target: target});
        target.fire('modified');

    },

    touchRotation: function (canvas: IEditorCanvas, self: any): void {

        const scaleThreshold = 2;
        const rotateDegreeThreshold = 7;
        const t = canvas._currentTransform;
        t.action = 'innerRotate';
        const e = canvas.__gesturesParams.e;
        const target: any = t.target as any;
        if (self.state == 'start') {
            target.previousRotation = 0;
        }
        if ((target instanceof SF.Editor.PhotoGroup || target instanceof SF.Editor.Text || target instanceof SF.Editor.Clipart) && Math.abs(self.rotation) > rotateDegreeThreshold && Math.abs(self.scale) < scaleThreshold) {

            target.previousTouches = e.touches;
            let currentAngle = 0;
            if (target instanceof SF.Editor.PhotoGroup) {
                currentAngle = target.photoObject.angle;
            } else if ((target as any) instanceof SF.Editor.Text || target instanceof SF.Editor.Clipart) {
                currentAngle = (target as IEditorText).angle;
            }

            target.previousRotation = target.previousRotation ? target.previousRotation : 0;
            let newAngle = currentAngle + (self.rotation - target.previousRotation);
            // normalize angle to -180 180 value
            if (newAngle > 180) {
                newAngle -= 360;
            } else if (newAngle < -180) {
                newAngle += 360;
            }
            if (target instanceof SF.Editor.PhotoGroup) {
                target.innerRotate(newAngle);
            } else {
                (target as IEditorText).angle = newAngle;
            }
            target.previousRotation = self.rotation;
            this._fire('innerRotating',  commonEventInfo(e, target, false, t));

        }

    },

    pinchZoom: function (canvas: IEditorCanvas, self: any): void {
        const transform = canvas._currentTransform;
        transform.action = 'scale';
        const e = canvas.__gesturesParams.e;
        const target: IEditorShape = transform.target as IEditorShape;
        if (target instanceof SF.Editor.PhotoGroup) {
            document.dispatchEvent(new CustomEvent('pinchZoomStart'));
            const photoObject: IEditorEditorPhoto = target.photoObject;
            if (self.state == 'start') {
                target.previousPinchZoom = 1;
            }

            target.previousTouches = e.touches;
            const zoom = target.getZoom();
            let zoomDelta = self.scale - (target.previousPinchZoom || 0);
            if ((((target as IEditorPhotoGroup).isImageTooLarge && (target as IEditorPhotoGroup).isImageTooLarge()) || Math.round(target.getZoom() * 100) / 100 > Math.round(this.errorConfiguration.zoomError * 100) / 100) && zoomDelta > 0) {
                return;
            }
            const newZoom = zoom + zoomDelta / 2;
            const minZoom = photoObject.getMinZoom();
            const maxZoom = target.canvas.errorConfiguration ? target.canvas.errorConfiguration.zoomError : 100;
            if (minZoom > newZoom || maxZoom < newZoom) {
                if (zoom === minZoom || zoom === maxZoom) {
                    return;
                }

                if (minZoom > newZoom) {
                    zoomDelta = minZoom - zoom;
                } else if (minZoom < newZoom) {
                    zoomDelta = maxZoom - zoom;
                }
            }

            target.zoom(zoomDelta / 2);
            (target as any).userZoom = photoObject.imagePosition.zoom;
            target.previousPinchZoom = self.scale;
            // Force reloading for a higher quality image if available
            target.photoObject.elementAdded = false;
            this._fire('scaling',  commonEventInfo(e,  target, false, transform));
        } else if (target instanceof SF.Editor.Clipart) {
            if (self.state == 'start') {
                target.previousPinchZoom = 1;
            }

            const zoomRatio = self.scale / (target.previousPinchZoom || 1);
            if (zoomRatio == 1) {
                return;
            }
            (target as IEditorEditorImage).setWidth((target as IEditorEditorImage).getWidth() * zoomRatio);
            (target as IEditorEditorImage).setHeight((target as IEditorEditorImage).getHeight() * zoomRatio);
            target.setCoords();
            (target as unknown as IEditorClipart).currentZoom = self.scale;
            target.previousPinchZoom = self.scale;
            // Force reloading for a higher quality image if available
            target.elementAdded = false;
            this._fire('scaling', commonEventInfo(e,  target, false, transform));

        }

    },

    _onTouchStart: function (e: any): void {
        e.preventDefault();
        if (this.mainTouchId === null) {
            this.mainTouchId = this.getPointerId(e);
        }
        this.__onMouseDown(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl;
        const eventTypePrefix = this._getEventPrefix();
        const addEventOptions = {passive: false};
        // @ts-ignore
        fabric.util.addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
        const _this = this;
        setTimeout(function (): void {
            // @ts-ignore
            fabric.util.addListener(fabric.document, 'touchmove', _this._onMouseMove, addEventOptions);
        }, 400);

        // Unbind mousedown to prevent double triggers from touch devices
        fabric.util.removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
    },

    _renderAll: function (): fabric.StaticCanvas {
        if (this.state && this.state.currentProject) {
            const project = this.state.currentProject;
            if (project.settings.isPagerViewModesVisible() && !this.state.groupCartItemIds && this.state.boardViewMode === SF.Model.ViewMode.SINGLE) {
                this.skipOffscreen = false;
            }
        }
        const lowerContext = this.contextContainer;
        const upperContext = this.contextTop || this.contextContainer;
        let objsToRender;

        // clear both context's
        this.clearContext(upperContext);
        this.clearContext(lowerContext);

        // fire before render
        this.fire('before:render');

        // apply clip
        FabricHelpers.clipContext(this, lowerContext);
        if (EditorHelpers.hasPatternObject(this) && this.clipTo) {
            lowerContext.save();
            lowerContext.beginPath();
            this.clipTo(lowerContext);
            lowerContext.clip();
        }

        // render background (render's the white that is set in initialize())
        this._renderBackground(lowerContext);
        this.renderCanvasBackgroundColor(lowerContext);

        // render objects
        lowerContext.save();
        objsToRender = this._chooseObjectsToRender();

        //apply viewport transform once for all rendering process
        lowerContext.transform.apply(lowerContext, this.viewportTransform);
        for (let i = 0; i < objsToRender.length; i++) {
            if (objsToRender[i].type == 'group' && this.getObjects().indexOf(objsToRender[i]) >= 0) {
                for (let j = 0; j < objsToRender[i]._objects.length; j++) {
                    objsToRender[i]._objects[j]._currentViewportTransform = this.viewportTransform;
                }
            }
        }

        this._renderObjects(lowerContext, objsToRender);

        if (!this.preserveObjectStacking) {
            this._renderObjects(lowerContext, [this.getActiveGroup()]);
        }
        lowerContext.restore();

        // undo clip
        FabricHelpers.unClipContext(this, lowerContext);
        if (EditorHelpers.hasPatternObject(this) && this.clipTo) {
            lowerContext.restore();
        }

        // fire after-render
        this.fire('after:render');
        SF.Editor.PostRenderer.render.apply(this);
        this.renderMasks();
        this.renderNonPrintableBackground();
        if (SF.Editor.PostRenderer.renderCanvasCorner && !(this.maskOverlayEnabled || this.nonPrintableBackgroundEnabled)) {
            SF.Editor.PostRenderer.renderCanvasCorner.apply(this);
        } else if (!SF.Editor.PostRenderer.renderCanvasCorner) {
            console.warn('SF.Editor.PostRenderer.renderCanvasCorner is not defined');
        }

        if (this.overlayImage && !fabric.isLikelyNode && !this.threeDpreview) {
            this.drawControls(lowerContext);
        } else {
        // draw controls on upper layer
        this.drawControls(upperContext);
        }

        if (SF.Editor.PostRenderer.loadingPatternImage) {
            SF.Editor.PostRenderer.loadingPatternImage.apply(this);
        }
        return this;
    },

    renderMasks: function (): void {
        if (this.maskOverlayEnabled) {
            document.dispatchEvent(new CustomEvent(EVENT_CANVAS_RENDER_MASK));
        }
    },

    renderNonPrintableBackground: function (): void {
        if (this.nonPrintableBackgroundEnabled) {
            document.dispatchEvent(new CustomEvent(EVENT_CANVAS_RENDER_NON_PRINTABLE_BACKGROUND));
        }
    },

    renderCanvasBackgroundColor: function (ctx: CanvasRenderingContext2D): void {
        if (this.enableCanvasMargin) {
            const zoom = this.getZoom();
            const objects = this.getObjects();
            if (!this.canvasBackgroundColor || (objects.length == 1 && objects[0].width * zoom >= this.width)) {
                return;
            }
            ctx.save();
            const originalFillStyle = ctx.fillStyle;
            ctx.fillStyle = this.canvasBackgroundColor;

            ctx.fillRect(
                0,
                0,
                this.width,
                this.height
            );
            ctx.fillStyle = originalFillStyle;
            ctx.restore();
        }
    },

    _clearSelection: function (e: Event, target: any, pointer: { x: number, y: number }): void {

        const isBackgroundAction = this.isBackgroundAction(target, pointer);

        // clean all
        this.discardActiveObject(e);

        // either select object or create group selector
        if (target && target.selectable && (target.type !== 'background' || (target.type === 'background' && isBackgroundAction))) {
            this.setActiveObject(target, e);
        }
    },
});

SF.Editor.PostRenderer.render = function (): void {
    const wrap = this.wrap;

    const isEditor = this instanceof SF.Editor.Canvas;

    // Only render the overlay if we are not JRS and vptCoords is set (ready to draw).
    if (this.overlayImage && !fabric.isLikelyNode) {
        const checkRenderOverlay = () => {
            if (this.vptCoords && this.vptCoords.tl && this.vptCoords.br) {
                if (!this.threeDpreview) {
                    this._renderOverlay(this.contextContainer);
                } else {
                    const upperContext = this.contextTop || this.contextContainer;
                    this._renderOverlay(upperContext);
                }
            } else {
                setTimeout(() => {
                    checkRenderOverlay();
                }, 300)
            }
        }
        checkRenderOverlay();

    }

    if (!wrap && !this.keyhole && !this.maskBW) {
        return;
    }

    if (this.keyhole && !fabric.isLikelyNode) {
        this.renderKeyHole();
    } else if (this.maskBW) {
        if (SF.Editor.PostRenderer.renderMask) {
            SF.Editor.PostRenderer.renderMask(this);
        } else {
            console.warn('SF.Editor.PostRenderer.renderMask is not defined');
        }

    } else {
        const ctx = this.getContext();
        const zoom = this.getZoom();
        const marginTop = isEditor ? this.marginTop : 0;
        const marginLeft = isEditor ? this.marginLeft : 0;

        // side (wrap)
        const lSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_LEFT] * zoom);
        const rSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_RIGHT] * zoom);
        const tSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_TOP] * zoom);
        const bSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_BOTTOM] * zoom);

        // back side (bleed)
        const lBack = Math.round(wrap[ProductAttribute.BLEED_BACK_LEFT] * zoom);
        const rBack = Math.round(wrap[ProductAttribute.BLEED_BACK_RIGHT] * zoom);
        const tBack = Math.round(wrap[ProductAttribute.BLEED_BACK_TOP] * zoom);
        const bBack = Math.round(wrap[ProductAttribute.BLEED_BACK_BOTTOM] * zoom);

        // aggregate
        const left = lSide + lBack;
        const top = tSide + tBack;
        const right = rSide + rBack;
        const bottom = bSide + bBack;
        const height = Math.round(wrap.height * zoom);
        const width = Math.round(wrap.width * zoom);
        const threeDpreviewBoard = !!this.threeDpreview;

        ctx.save();

        if (wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.BORDER || wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.BORDER_WHITE) {
            SF.Editor.PostRenderer.drawBorder(ctx, wrap[WrapOptions.EDGE_COLOR], marginLeft, marginTop, left, top, bottom, right, width, height);
        } else if (wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.MIRROR_WRAP) {
            if (SF.Editor.PostRenderer.drawMirror) {
                SF.Editor.PostRenderer.drawMirror(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
            } else {
                console.warn('SF.Editor.PostRenderer.drawMirror is not defined');
            }
        } else if (wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.MIRROR_WRAP_WITH_BLUR) {
            if (this.objectsToLoad == 0) {
                if (SF.Editor.PostRenderer.drawMirrorWithBlur) {
                    SF.Editor.PostRenderer.drawMirrorWithBlur(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                } else {
                    console.warn('SF.Editor.PostRenderer.drawMirrorWithBlur is not defined');
                }
            }
        } else if (wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.IMAGE_WRAP_WITH_BLUR) {
            if (SF.Editor.PostRenderer.drawImageWrapWithBlur) {
                SF.Editor.PostRenderer.drawImageWrapWithBlur(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
            } else {
                console.warn('SF.Editor.PostRenderer.drawImageWrapWithBlur is not defined');
            }
        } else if (wrap[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.EXTEND) {
            if (this.objectsToLoad == 0) {
                if (SF.Editor.PostRenderer.drawExtend) {
                    SF.Editor.PostRenderer.drawExtend(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                } else {
                    console.warn('SF.Editor.PostRenderer.drawExtend is not defined');
                }
            }
        }

        ctx.restore();
    }
};

SF.Editor.PostRenderer.loadingPatternImage = function (): void {
    if (this.objectsToLoad === 0) {
        void EditorHelpers.loadPatternImages(this);
    }
};

SF.Editor.PostRenderer.renderCanvasCorner = function (): void {
    const wrap = this.wrap;
    const ctx = this.getSelectionContext();
    ctx.save();
    const zoom = this.getZoom();
    const CornerTypes = SF.Model.CornerTypes;
    let color = 'rgb(255, 255, 255)';
    const previewContainer = document.getElementById('preview-container');
    if (previewContainer) {
        color = getComputedStyle(previewContainer).backgroundColor;
    }
    // draw wrap
    if (!wrap || !wrap[WrapOptions.CORNER_TYPE]) {
        return;
    }

    // side (wrap)
    const lSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_LEFT] * zoom);
    const rSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_RIGHT] * zoom);
    const tSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_TOP] * zoom);
    const bSide = Math.round(wrap[ProductAttribute.BLEED_SIDE_BOTTOM] * zoom);

    // back side (bleed)
    const lBack = Math.round(wrap[ProductAttribute.BLEED_BACK_LEFT] * zoom);
    const rBack = Math.round(wrap[ProductAttribute.BLEED_BACK_RIGHT] * zoom);
    const tBack = Math.round(wrap[ProductAttribute.BLEED_BACK_TOP] * zoom);
    const bBack = Math.round(wrap[ProductAttribute.BLEED_BACK_BOTTOM] * zoom);

    // aggregate
    const left = lSide + lBack;
    const top = tSide + tBack;
    const right = rSide + rBack;
    const bottom = bSide + bBack;
    const height = Math.round(this.height);
    const width = Math.round(this.width);
    let edges = [];

    // first, white out area
    ctx.fillStyle = color;
    fillRect(-1, -1, left + 1, height + 2, ctx, this);
    fillRect(width - right, -1, right + 1, height + 2, ctx, this);
    fillRect(left, -1, width - left - right, top + 1, ctx, this);
    fillRect(left, height - bottom, width - left - right, bottom + 1, ctx, this);

    // any further drawing should be subtractive
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = color;
    ctx.globalAlpha = 0.6;

    // draw wrap
    fillRect(lBack, top, lSide - 1, height - top - bottom, ctx, this);
    fillRect(width - right + 1, top, rSide - 1, height - top - bottom, ctx, this);
    fillRect(left, tBack, width - left - right, tSide - 1, ctx, this);
    fillRect(left, height - bottom + 1, width - left - right, bSide - 1, ctx, this);

    // draw bleed
    switch (wrap[WrapOptions.CORNER_TYPE]) {
        case CornerTypes.HORIZONTAL_FOLD:
            edges = [
                // left
                [left, height - bottom],
                [0, height - bottom],
                [0, top],
                [left, top],

                // top
                [left, tBack],
                [left + lBack, tBack],
                [left + lBack, 0],
                [width - right - rBack, 0],
                [width - right - rBack, tBack],
                [width - right, tBack],
                [width - right, top],

                // right
                [width, top],
                [width, height - bottom],
                [width - right, height - bottom],

                // bottom
                [width - right, height - bBack],
                [width - right - rBack, height - bBack],
                [width - right - rBack, height],
                [left + lBack, height],
                [left + lBack, height - bBack],
                [left, height - bBack],
                [left, height - bottom]
            ];

            fillRect(0, top, lBack - 1, height - top - bottom, ctx, this);
            fillRect(width - rBack + 1, top, rBack - 1, height - top - bottom, ctx, this);
            fillRect(right + lBack, 0, width - left - right - lBack - rBack, tBack - 1, ctx, this);
            fillRect(right + lBack, height - bBack + 1, width - left - right - lBack - rBack, tBack - 1, ctx, this);
            break;

        case CornerTypes.VERTICAL_FOLD:
            edges = [
                // left
                [left, height - bottom],
                [lBack, height - bottom],
                [lBack, height - bottom - bBack],
                [0, height - bottom - bBack],
                [0, top + tBack],
                [lBack, top + tBack],
                [lBack, top],
                [left, top],

                // top
                [left, 0],
                [(width - right), 0],
                [(width - right), top],

                // right
                [width - rBack, top],
                [width - rBack, top + tBack],
                [width, top + tBack],
                [width, height - bottom - bBack],
                [width - rBack, height - bottom - bBack],
                [width - rBack, height - bottom],
                [width - right, height - bottom],

                // bottom
                [width - right, height],
                [left, height],
                [left, height - bottom]
            ];

            fillRect(0, top + tBack, lBack - 1, height - top - bottom - tBack - bBack, ctx, this);
            fillRect(width - rBack + 1, top + tBack, rBack - 1, height - top - bottom - tBack - bBack, ctx, this);
            fillRect(right, 0, width - left - right, tBack - 1, ctx, this);
            fillRect(right, height - bBack + 1, width - left - right, tBack - 1, ctx, this);
            break;

        case CornerTypes.DIAGONAL_FOLD:
            edges = [
                [lBack, height - bottom],
                [0, height - bottom - bBack],
                [0, top + tBack],                               // top left
                [lBack, top],                                   // top right

                // top
                [left, top],
                [left, tBack],
                [left + lBack, 0],
                [width - right - rBack, 0],
                [width - right, tBack],
                [width - right, top],

                // right
                [width - rBack, top],
                [width, top + tBack],
                [width, height - bottom - bBack],
                [width - rBack, height - bottom],
                [width - right, height - bottom],

                // bottom
                [width - right, height - bBack],
                [width - right - rBack, height],
                [left + lBack, height],
                [left, height - bBack],
                [left, height - bottom]
            ];

            // left
            ctx.beginPath();
            moveTo(edges[2][0], edges[2][1], ctx, this);
            lineTo(edges[3][0] - 1, edges[3][1], ctx, this);
            lineTo(edges[0][0] - 1, edges[0][1], ctx, this);
            lineTo(edges[1][0], edges[1][1], ctx, this);
            ctx.closePath();
            ctx.fill();

            // right
            ctx.beginPath();
            moveTo(width - 1, top + tBack, ctx, this);
            lineTo(width - rBack + 1, top, ctx, this);
            lineTo(width - rBack + 1, height - bottom, ctx, this);
            lineTo(width - 1, height - bottom - bBack, ctx, this);
            ctx.closePath();
            ctx.fill();

            // top
            ctx.beginPath();
            moveTo(left, tBack - 1, ctx, this);
            lineTo(left + lBack, 0, ctx, this);
            lineTo(width - right - rBack, 0, ctx, this);
            lineTo(width - right, tBack - 1, ctx, this);
            ctx.closePath();
            ctx.fill();

            // bottom
            ctx.beginPath();
            moveTo(left, height - bBack + 1, ctx, this);
            lineTo(left + lBack, height - 1, ctx, this);
            lineTo(width - right - rBack, height - 1, ctx, this);
            lineTo(width - right, height - bBack + 1, ctx, this);
            ctx.closePath();
            ctx.fill();

            break;
        default:
            return;
    }

    // finally, draw the border
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 1;
    ctx.globalCompositeOperation = 'source-over';

    ctx.beginPath();
    moveTo(edges[0][0], edges[0][1], ctx, this);

    for (let i = 1; i < edges.length; i++) {
        lineTo(edges[i][0], edges[i][1], ctx, this);
    }

    ctx.closePath();
    ctx.stroke();
    ctx.restore();
};

fabric.Object.prototype._getControlsVisibility = function (): {
    tl: boolean,
    tr: boolean,
    br: boolean,
    bl: boolean,
    ml: boolean,
    mt: boolean,
    mr: boolean,
    mb: boolean,
    mtr: boolean,
    ir: boolean
} {
    // @ts-ignore
    const mtrIsVisible = fabric.Object.prototype.handleLayout != HandleLayout.MOBILE;

    if (!this._controlsVisibility) {
        this._controlsVisibility = {
            tl: true,
            tr: true,
            br: true,
            bl: true,
            ml: true,
            mt: true,
            mr: true,
            mb: true,
            ir: !fabric.isTouchSupported
        };
    }

    this._controlsVisibility.mtr = mtrIsVisible;
    this._controlsVisibility.ir = !fabric.isTouchSupported;
    return this._controlsVisibility;
};

function fillRect(x: number, y: number, width: number, height: number, ctx: CanvasRenderingContext2D, canvas: IEditorCanvas): void {
    const mTop = canvas.marginTop || 0;
    const mLeft = canvas.marginLeft || 0;
    ctx.fillRect(mLeft + x, mTop + y, width, height);
}

function lineTo(x: number, y: number, ctx: CanvasRenderingContext2D, canvas: IEditorCanvas): void {
    const mTop = canvas.marginTop || 0;
    const mLeft = canvas.marginLeft || 0;
    ctx.lineTo(mLeft + x, mTop + y);
}

function moveTo(x: number, y: number, ctx: CanvasRenderingContext2D, canvas: IEditorCanvas): void {
    const mTop = canvas.marginTop || 0;
    const mLeft = canvas.marginLeft || 0;
    ctx.moveTo(mLeft + x, mTop + y);
}
